<template>
	<div class="rasa-dashbord">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="wellcom-box">
						<strong>{{ customer.fullName }} عزیز به پنل قبول آنی رسان خوش آمدید</strong><br />
						<div class="pt-5 ps-3 pb-5 text-start">
						<div>
							<i style="font-size:20px;" class="bi text-warning bi-cash-stack me-2"></i><span> شارژ پنل شما برابر با {{ new Intl.NumberFormat().format(customer.leftCharge) }} ریال می باشد.</span>
						</div>
						<div>
							<i style="font-size:20px;" class="bi text-warning bi-file-earmark-person me-2"></i><span>شماره اشتراک شما جهت ارجاع و ثبت کد معرف {{customer.customerId}} می باشد.</span>
						</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-md-4">
					<router-link to="/club/tracking-parcels">
						<div class="route-box">
							<strong> رهگیری قدم به قدم مرسولات </strong>
							<img src="../../../assets/img/dashbord/form.png" />
						</div>
					</router-link>
				</div>
				<div class="col-12 col-md-4">
					<router-link to="/club/price-inquery">
						<div class="route-box">
							<strong> استعلام قیمت مرسوله </strong>
							<img src="../../../assets/img/dashbord/form.png" />
						</div>
					</router-link>
				</div>
				<div class="col-12 col-md-4">
					<router-link to="/club/accept-parcel">
						<div class="route-box">
							<strong> ثبت مرسوله </strong>
							<img src="../../../assets/img/dashbord/form2.png" />
						</div>
					</router-link>
				</div>
				<div class="col-12 col-md-4">
					<router-link to="/club/charge-wallet">
						<div class="route-box">
							<strong> شارژ کیف پول </strong>
							<img src="../../../assets/img/dashbord/walet.png" />
						</div>
					</router-link>
				</div>
				<div class="col-12 col-md-4">
					<router-link to="/club/parcels">
						<div class="route-box">
							<strong> مرسولات شما </strong>
							<img src="../../../assets/img/dashbord/box.png" />
						</div>
					</router-link>
				</div>
				<div class="col-12 col-md-4">
					<router-link to="/club/financial-report">
						<div class="route-box">
							<strong> گزارشات مالی </strong>
							<img src="../../../assets/img/dashbord/list.png" />
						</div>
					</router-link>
				</div>
				<div class="col-12 col-md-4">
					<router-link to="/club/reset-password">
						<div class="route-box">
							<strong> تغییر کلمه عبور </strong>
							<img src="../../../assets/img/dashbord/pin.png" />
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import store from "@/common/store";
	export default {
		data()
		{
			return {
				customer: store.customer
			}
		}
	}
</script>

<style>
	.rasa-dashbord {
		width: 100%;
		height: auto;
	}

		.rasa-dashbord .wellcom-box {
			width: 100%;
			min-height: 120px;
			margin: 0px 0px 10px 0;
			border-radius: 10px 40px 10px 40px;
			border-right: #ffc600 solid 2px;
			border-left: #ffc600 solid 2px;
			text-align: center;
			padding-top: 30px;
			background: #fff;
		}

		.rasa-dashbord .route-box {
			width: 100%;
			height: 150px;
			margin: 0px 0px 10px 0;
			border-radius: 10px;
			/*box-shadow: 0px 0px 10px 0px #ddd;*/
			border-bottom: #ddd solid 2px;
			background: #fff;
			transition: all .3s;
		}

			.rasa-dashbord .route-box:hover {
				transform: scale(1.05);
				background: #f8f8f8;
			}

			.rasa-dashbord .route-box strong {
				margin: 60px 20px 0 0;
				display: inline-block;
			}

			.rasa-dashbord .route-box strong {
				color: #000;
			}

			.rasa-dashbord .route-box img {
				width: 70px;
				height: 70px;
				float: left;
				margin: 30px 0px 0 30px;
			}
</style>
